export enum SearchType {
  AGENT = 'AGENT',
  BROKER = 'BROKER',
}
